<template>
  <div  class="sign-list">
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'meeting-list'}">活动列表</BreadcrumbItem>
      <BreadcrumbItem>发票信息</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <h2>{{ meeting.title }}</h2>
      <Card >
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          发票信息列表
        </p>
        <a slot="extra" :href="`/api/admin/meetings/${meetingId}/signs/invoices/export`"><Icon type="ios-download-outline"></Icon> 导出全部信息</a>
        <Table :columns="columns" :data="rows" :show-header="true" ref="table"></Table>
      </Card>
    </div>
    <Modal title="查看图片" v-model="visible" cancel-text="" style="text-align: center">
      <img :src="'/api/admin/meetings/cover/show?path=' + viewImgPath" v-if="visible" style="width: 100%">
    </Modal>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'

export default {
  name: 'InvoiceList',
  props: ['meetingId'],
  data () {
    return {
      remoteStatus: null,
      signs: [],
      meeting: {signSetting: {
        signMeetingSteps: []
      }},
      tableLoading: true,
      visible: false,
      viewImgPath: '',
      columnsStart: [
        {
          title: '报名时间',
          key: 'createDate',
          render: (h, params) => {
            return h('div', this.formatDate(params.row.createDate))
          }
        },
        {
          title: '企业名称',
          key: 'companyName'
        },
        {
          title: '参会人',
          key: 'attendeesNames'
        }
      ]
    }
  },
  computed: {
    columns () {
      let signColumns = this.columnsStart
      if (this.meeting.signSetting.uploadBankSlip) {
        signColumns.push({
          title: '银行回执单',
          key: 'bankSlipFilePath',
          render: (h, params) => {
            if (params.row.bankSlipFilePath) {
              return h('div', [
                h('img', {
                  attrs: {
                    width: '160',
                    height: '100',
                    src: `/api/admin/meetings/cover/show?path=${params.row.bankSlipFilePath}`
                  },
                  on: {
                    click: () => {
                      this.handleView(params.row.bankSlipFilePath)
                    }
                  },
                  style: {
                    'vertical-align': 'middle',
                    'cursor': 'pointer'
                  }
                })
              ])
            } else {
              return h('span', '未上传')
            }
          }
        })
      }

      if (this.meeting.signSetting.showInvoice) {
        signColumns.push({
          title: '发票信息',
          key: 'invoiceType',
          width: 300,
          render: (h, params) => {
            let elements = []
            if (params.row.invoiceType === 1) {
              elements.push(h('p', `发票类型： ${this.getInvoiceTypeText(params.row.invoiceType)}`))
              elements.push(h('p', `发票抬头：${params.row.invoiceTitle}`))
            } else if (params.row.invoiceType === 2) {
              elements.push(h('p', `发票类型： ${this.getInvoiceTypeText(params.row.invoiceType)}`))
              elements.push(h('p', `单位名称：${params.row.invoiceCompanyName}`))
              elements.push(h('p', `纳税人识别码：${params.row.invoiceTaxpayerIdentificationCode}`))
              elements.push(h('p', `公司注册地址：${params.row.invoiceRegisteredOfficeAddress}`))
              elements.push(h('p', `公司注册电话：${params.row.invoiceRegisteredOfficePhone}`))
              elements.push(h('p', `开户银行：${params.row.invoiceDepositBank}`))
              elements.push(h('p', `银行账户：${params.row.invoiceBankAccount}`))
            } else {
              elements.push(h('p', `不需要发票`))
            }

            return h('div', elements)
          }
        })
        signColumns.push({
          title: '收票人信息',
          key: 'invoiceType',
          width: 180,
          render: (h, params) => {
            if (params.row.invoiceType === 1 || params.row.invoiceType === 2) {
              let elements = []
              elements.push(h('p', `姓名： ${params.row.invoiceRecipientName}`))
              elements.push(h('p', `手机：${params.row.invoiceRecipientPhone}`))
              elements.push(h('p', `地址：${params.row.invoiceRecipientAddress}`))
              elements.push(h('p', `邮编'：${params.row.invoiceRecipientZipCode}`))
              return h('div', elements)
            }
          }
        })
      }

      return signColumns
    },
    rows () {
      return this.signs
    }
  },
  methods: {
    getInvoiceTypeText (invoiceType) {
      if (invoiceType === 0) {
        return '不需要发票'
      } else if (invoiceType === 1) {
        return '增值税普通发票'
      } else if (invoiceType === 2) {
        return '增值税专用发票'
      }

      return ''
    },
    handleView (imgPath) {
      console.log('view')
      this.viewImgPath = imgPath
      this.visible = true
    },
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/signs`)
      let meeting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}`)).body
      next(vm => {
        vm.remoteStatus = resp.status
        vm.signs = resp.body
        vm.meeting = meeting
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.signs = []
        vm.meeting = {}
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/meetings/${this.meetingId}/signs`)
      let meeting = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}`)).body

      this.remoteStatus = resp.status
      this.signs = resp.body
      this.meeting = meeting
      next()
    } catch (e) {
      this.remoteStatus = e.status
      this.signs = []
      this.meeting = {}
      next()
    }
  }
}
</script>

<style>
  .sign-list .ivu-table-cell {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/meeting/InvoiceList.vue